export default {"src":"/_next/static/media/dashboard-icon.d4e42c86.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};